"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

var React = _interopDefault(require("react")),
    ScrollInto = function ScrollInto(e) {
  function t() {
    var e = {
      behavior: r ? "smooth" : "instant"
    };
    s && (e.block = "start", e.inline = "nearest"), document.querySelector(n).scrollIntoView(e);
  }

  var o = e.children,
      n = e.selector,
      i = e.smooth,
      r = void 0 === i || i,
      l = e.style,
      c = void 0 === l ? {} : l,
      a = e.alignToTop,
      s = void 0 !== a && a,
      u = e.className,
      f = void 0 === u ? "" : u,
      d = e.onClick;
  return React.createElement("div", {
    style: c,
    className: f,
    onClick: function onClick(e) {
      "function" == typeof d ? (d(e), setTimeout(t, 1e3 / 60)) : t();
    }
  }, o);
};

module.exports = ScrollInto;